import { render } from "./Company-page.vue?vue&type=template&id=56ea10b6&scoped=true"
import script from "./Company-page.vue?vue&type=script&lang=js"
export * from "./Company-page.vue?vue&type=script&lang=js"

import "./Company-page.vue?vue&type=style&index=0&id=56ea10b6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ea10b6"]])

export default __exports__